import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-regular-svg-icons'

function NotificationCard({ subject, text, date, onDelete }) {
    return (
      <div className="notifycard mb-2">
        <div>
            <p className="mb-0 fw-semibold text-white mb-2" style={{fontSize: '13px'}}>{subject} <span className="text-secondary ms-1">{date}</span></p>
            <p className="mb-0 text-secondary" style={{fontSize: '13px'}}>{text}</p>
        </div>
        <FontAwesomeIcon icon={faTrashCan} style={{color: 'gray', cursor: 'pointer', fontSize: '14px'}} onClick={onDelete} />
      </div>
    )
  }
  
  export default NotificationCard